<mat-sidenav-container
    [ngClass]="{
        sideBarCollapsed: sideBarCollapsed,
        sideBarUnCollapsed: !sideBarCollapsed,
        isSearchBoxActive: isSearchBoxActive | async
    }"
    class="app-sidenav-container sidnav-menu-wrapper-container"
>
    <mat-sidenav
        mode="side"
        [opened]="isOpen"
        (mouseenter)="isSmallScreen && (sideBarCollapsed = false)"
        (mouseleave)="isSmallScreen && (sideBarCollapsed = true)"
        [disableClose]="true"
        class="app-sidenav main-side-nave-parent header-visible"
        data-testid="app-sidebar"
    >
        <div class="white-bg-wrapper"></div>
        <div class="white-bg-wrapper first"></div>
        <ng-content select="app-sidebar-menu"></ng-content>
        <div (click)="collapseToggle()" class="collapse-wrapper">
            <mat-icon>menu_open</mat-icon>
            <span i18n>Collapse</span>
        </div>
    </mat-sidenav>

    <div class="side-nav-content">
        <article class="app-content">
            <ng-content></ng-content>
        </article>

        <app-footer></app-footer>
    </div>
</mat-sidenav-container>
